import dotenv from 'dotenv';

dotenv.config({ silent: true });
